export default __webpack_public_path__ + "static/media/undraw_mail_done.53aee0da.png";